module.exports = __webpack_public_path__ + "img/img09.027ce2cd.png";